import { storage } from './utils'
const mapType = 'mapType'
const caseType = 'caseType'
const currentSectionNo = 'currentSectionNo'
const isCompleted = 'isCompleted'
const q240Answer = 'q240Answer'
const q158Answer = 'q158Answer'
const isFaceSheetCompleted = 'isFaceSheetCompleted'
const isPreSectionCompleted = 'isPreSectionCompleted'
const isIntakeCompleted = 'isIntakeCompleted'
const faceSheetCurrentPageNo = 'faceSheetCurrentPageNo'
const preSectionCurrentPageNo = 'preSectionCurrentPageNo'
const intakeCurrentPageNo = 'intakeCurrentPageNo'
export const getMapType = {
  get: () => {
    return storage.getmapDetails(mapType)
  },
  set: (value) => {
    storage.setmapDetails(mapType, value)
  },
}

export const getCaseType = {
  get: () => {
    return storage.getmapDetails(caseType)
  },
  set: (value) => {
    storage.setmapDetails(caseType, value)
  },
}

export const getCurrentSectionNo = {
  get: () => {
    return storage.getmapDetails(currentSectionNo)
  },
  set: (value) => {
    storage.setmapDetails(currentSectionNo, value)
  },
}

export const getIsCompleted = {
  get: () => {
    return storage.getmapDetails(isCompleted)
  },
  set: (value) => {
    storage.setmapDetails(isCompleted, value)
  },
}

export const getQ240Answer = {
  get: () => {
    return storage.getmapDetails(q240Answer)
  },
  set: (value) => {
    storage.setmapDetails(q240Answer, value)
  },
}

export const getQ158Answer = {
  get: () => {
    return storage.getmapDetails(q158Answer)
  },
  set: (value) => {
    storage.setmapDetails(q158Answer, value)
  },
}

export const getIsFaceSheetCompleted = {
  get: () => {
    return storage.getmapDetails(isFaceSheetCompleted)
  },
  set: (value) => {
    storage.setmapDetails(isFaceSheetCompleted, value)
  },
}

export const getIsPreSectionCompleted = {
  get: () => {
    return storage.getmapDetails(isPreSectionCompleted)
  },
  set: (value) => {
    storage.setmapDetails(isPreSectionCompleted, value)
  },
}

export const getIsIntakeCompleted = {
  get: () => {
    return storage.getmapDetails(isIntakeCompleted)
  },
  set: (value) => {
    storage.setmapDetails(isIntakeCompleted, value)
  },
}

export const getFaceSheetCurrentPageNo = {
  get: () => {
    return storage.getmapDetails(faceSheetCurrentPageNo)
  },
  set: (value) => {
    storage.setmapDetails(faceSheetCurrentPageNo, value)
  },
}

export const getPreSectionCurrentPageNo = {
  get: () => {
    return storage.getmapDetails(preSectionCurrentPageNo)
  },
  set: (value) => {
    storage.setmapDetails(preSectionCurrentPageNo, value)
  },
}

export const getIntakeCurrentPageNo = {
  get: () => {
    return storage.getmapDetails(intakeCurrentPageNo)
  },
  set: (value) => {
    storage.setmapDetails(intakeCurrentPageNo, value)
  },
}
